export default __webpack_public_path__ + "static/media/Group_8421.dcde4b74.svg";